import React from 'react';

// Types
import { CreateAccountFlowType } from './types';

// Components
import SidePanel from './SidePanel';
import SignUpBody from './SignUpBody';

// Styles
import './SignUpPage.scss';

type Props = {
  flowType?: CreateAccountFlowType;
  askForName?: boolean;
  isPiCompany?: boolean;
  askForRole?: boolean;
  title?: string;
  subTitle?: string;
  inviterSlug?: string;
  workspaceSlug?: string;
  currentEmail?: string;
  invitationToken?: string;
  withCalendar?: boolean;
};

const SignUpPage = ({
  flowType = CreateAccountFlowType.signUp,
  askForName = false,
  isPiCompany = false,
  askForRole = false,
  title,
  subTitle,
  inviterSlug,
  workspaceSlug,
  currentEmail,
  invitationToken,
  withCalendar,
}: Props) => {
  const baseClassName = 'SignUpPage';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__sidepanel`}>
        <SidePanel />
      </div>
      <SignUpBody
        flowType={flowType}
        askForName={askForName}
        isPiCompany={isPiCompany}
        askForRole={askForRole}
        title={title}
        subTitle={subTitle}
        inviterSlug={inviterSlug}
        workspaceSlug={workspaceSlug}
        currentEmail={currentEmail}
        invitationToken={invitationToken}
        withCalendar={withCalendar}
      />
    </div>
  );
};

export default SignUpPage;
